import { getCookie, setCookie, delCookie} from '../env/util'
import config from "../env/config"

export default {
    data(){
        return {
            user_info : {},
            project_name : '',
            dateNullTip:'日期为空，则默认显示所有的日期',
            locNullTip:'地点为空，则默认选择所有地点',
            typeNullTip:'类型为空，则默认选择所有类型'
        }
    },
    async mounted () {
        // this.project_name = config.PROJECT_NAME;
        let orderHeight = document.documentElement.clientHeight;
        let mainheaderHeight = document.getElementById('main-header').style.height;
        document.getElementById('main-content').style.height = (orderHeight - mainheaderHeight.replace(/[^0-9]/ig,"")) +'px'
    },
    methods : {
        
        // 对象按照某个属性数组按照中文排序
        sortChinese (arr, dataLeven) { // 参数：arr 排序的数组; dataLeven 数组内的需要比较的元素属性
            /* 获取数组元素内需要比较的值 */
            function getValue (option) { // 参数： option 数组元素
              if (!dataLeven) return option
              var data = option
              dataLeven.split('.').filter(function (item) {
                data = data[item]
              })
              return data + ''
            }
            arr.sort(function (item1, item2) {
              return getValue(item1).localeCompare(getValue(item2), 'zh-CN');
            })
        },

        /**
         * 获取券的总量
         * @param { Object } result 
        */
        totalTicket(result){
          let total =  result.reduce((total,Qty) => total + Number(Qty.qty),0) ;
          return total ;
        },

        /**
         * 
         * @param {*} num 
         */
        unTotalTicket(result){
          let total =  result.reduce((total,Qty) => total + Number(Qty.qty),0) ;
          return total ;
        },
        unTotalTicket2(result){
          let total =  result.reduce((total,Qty) => total + Number(Qty.currentGeneratedQty),0) ;
          return total ;
        },
        
        /**
         * @param { number } num 数字
         * 逢三位转逗号
        */
        changeTree(num) {
        //   var num = (num || 0).toString();
        //   var result = '';
        //   while (num.length > 3 && num.charAt(0) !== '-') {
        //       result = ',' + num.slice(-3) + result;
        //       num = num.slice(0, num.length - 3);
        //   }
        //   if (num) { result = num + result; }
        //   return result;
            return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
        },

        /**
         * 去除左右空格
         */
        trim(s){
          return s.replace(/(^\s*)|(\s*$)/g, "");
        },

        //格式化 状态
        formalStatus(status){
            let newStatus ;
            switch(status){
                case "G" :
                    newStatus = '生成' ;
                break ;
                case "C" :
                    newStatus = '确认' ;
                    break ;
                case "D" :
                    newStatus = "分配" ;
                    break;
                case "A" :
                    newStatus = "激活" ;
                    break;
                case "S" :
                    newStatus = "销售" ;
                    break;
                case "R" :
                    newStatus = "核销" ;
                    break;
                case "M" :
                    newStatus = "调整" ;
                break;
            }
            return newStatus ;
        },
        //默认显示当前日期
        checkTime(i){
            if (i<10){
                i ="0" + i
            }
            return i;
        },
        defaultNow(){
            let defaultVal = [] ;
            defaultVal[0] = new Date() ;
            defaultVal[0] = defaultVal[0].getFullYear() + '-' + this.checkTime(defaultVal[0].getMonth() + 1) + '-' + this.checkTime(defaultVal[0].getDate()) ;
            defaultVal[1] = defaultVal[0] ;
            return defaultVal;
        },
        //转换成时分秒
        formatSeconds(value) {
            let result = parseInt(value)
            let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
            let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
            let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
            result = `${h}:${m}:${s}`
            return result;
        }
    }
}